import { BadCustomerReviewPage, ErrorPage, FlinksMaintenanceGate, reportErrorToServer } from '@applyonline/shared'
import { EFinancingProgram } from '@if/core/types'
import { useEffect, type JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { Route, Routes, useSearchParams } from 'react-router-dom'
import CancelApplicationPage from '../CancelApplication/CancelApplicationPage'
import ConsignoCallBack from '../ConsignoCallBack'
import ContractWaitingPage from '../Contract/ContractWaitingPage'
import FlinksIncomeValidationPage from '../Flinks/FlinksIncomeValidationPage'
import FlinksPage from '../Flinks/FlinksPage'
import TermsAndConditionFlinksPage from '../Flinks/TermsAndConditionFlinksPage'
import MerchantMissingPage from '../MerchantMissingPage'
import RefinancePage from '../Refinance/RefinancePage'
import AddCoapplicantPage from '../SubmitNewApp/AddCoapplicantPage'
import SubmitNewAppPage from '../SubmitNewApp/SubmitNewAppPage'
import UpdatePersonalInformationForm from '../SubmitNewApp/UpdatePersonalInformationForm'
import ValidateRecaptchaFailedPage from '../ValidateRecaptchaFailedPage/ValidateRecaptchaFailedPage'
import RouteToStatePage from '../ViewCreditApplication/RouteToStatePage'
import WelcomePage from '../Welcome/WelcomePage'

const TopLevelRoutes = (): JSX.Element => {
  const { t, i18n } = useTranslation()
  const [searchParams] = useSearchParams()
  const lang = searchParams.get('lang')

  useEffect(() => {
    if (lang) {
      i18n.changeLanguage(lang).catch(reportErrorToServer)
    }
  }, [i18n, lang])

  return (
    <Routes>
      <Route path="/" element={<WelcomePage />} />
      <Route path="/:merchantId/" element={<WelcomePage />} />
      <Route path="/:merchantId/new-app/:currentStep" element={<SubmitNewAppPage />} />
      <Route path="/refinancingCreditApplication/:id" element={<RefinancePage />} />
      <Route path="/creditapplication/:id/addcoapplicant/:currentStep" element={<AddCoapplicantPage />} />
      <Route
        path="/creditapplication/:id/flinks/:applicantType"
        element={
          <FlinksMaintenanceGate>
            <FlinksPage />
          </FlinksMaintenanceGate>
        }
      />
      <Route path="/creditapplication/:id/flinks/:applicantType/terms" element={<TermsAndConditionFlinksPage />} />
      <Route
        path="/creditapplication/:id/flinks/:applicantType/validate"
        element={
          <FlinksMaintenanceGate>
            <FlinksIncomeValidationPage />
          </FlinksMaintenanceGate>
        }
      />
      <Route path="/creditapplication/:id/cancel" element={<CancelApplicationPage />} />
      <Route path="/recaptcha-validation-failed/*" element={<ValidateRecaptchaFailedPage />} />
      <Route path="/creditapplication/:id/badreview" element={<BadCustomerReviewPage financingProgram={EFinancingProgram.Personal} />} />
      <Route path="/creditapplication/:id/consignoCallBack/:applicantType?" element={<ConsignoCallBack />} />
      <Route path="/creditapplication/:id/contract" element={<ContractWaitingPage />} />
      <Route
        path="/:merchantId/creditapplication/:id/editPersonalInformation/:applicantType?/:currentStep"
        element={<UpdatePersonalInformationForm />}
      />

      <Route path="/creditapplication/:id/*" element={<RouteToStatePage />} />
      <Route path="/get-merchant-error/not-found" element={<MerchantMissingPage reason="merchantNotFound" />} />
      <Route path="/get-merchant-error/inactive" element={<MerchantMissingPage reason="merchantInactive" />} />
      <Route path="/*" element={<ErrorPage title={t('common.notFound')} />} />
    </Routes>
  )
}

export default TopLevelRoutes
